import { all } from 'redux-saga/effects';
import { watchLogin } from './Login/loginSaga';
import watchModeChange from './darkModeSaga';

const rootSaga = function* rootSaga() {
  yield all([
    watchLogin(),
    watchModeChange(),
  ]);
};

export default rootSaga;
